import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-expend",
  "use": "icon-expend-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" fill=\"none\" id=\"icon-expend\">\r\n          <path d=\"M4 6L7 9L10 6\" stroke=\"#19191A\" />\r\n        </symbol>"
});
var result = sprite.add(symbol);
export default symbol